module.exports = __webpack_public_path__ + "static/kitchen_2K-870256080a1ce6e3f5ca420f7b97f598.webp";